<template>
  <div class="page-profile-edit">
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      :label-position="labelPosition"
    >
      <el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Nombre Usuario">
            <el-input v-model="form.UserName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Email">
            <el-input v-model="form.Email" disabled type="email" />
          </el-form-item>
        </el-col>
      </el-col>
      <el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Nombres">
            <el-input v-model="form.FirstName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Apellidos">
            <el-input v-model="form.LastName" disabled />
          </el-form-item>
        </el-col>
      </el-col>
      <el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Cumpleaños">
            <el-date-picker
              type="date"
              placeholder="Pick a date"
              v-model="form.BirthDate"
              disabled
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Telefono">
            <el-input
              v-model="form.PhoneNumber"
              disabled
              placeholder="+xx xxx xxx xxxx"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <el-form-item label="Sexo">
            <el-radio-group v-model="form.gender" disabled>
              <el-radio label="Masculino" border></el-radio>
              <el-radio label="Femenino" border></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
      </el-col>
      <el-col>
        <el-col :span="12" :md="12" :sm="24" :xs="24" class="col-p">
          <!-- <el-form-item label="Foto">
            <el-upload
              class="upload-demo"
              action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
              :on-success="handleSuccessResponse"
              list-type="picture"
              accept="image/png, image/jpeg"
              :multiple="false"
              :show-file-list="false"
            >
               <el-button size="small" type="primary">Subir foto <i class="fa fa-upload"></i></el-button>
              <div slot="tip" class="el-upload__tip">
                Solo archivos jpg/png con un tamaño menor de 500kb
              </div>
            </el-upload>
          </el-form-item> -->
        </el-col>
      </el-col>

      <el-col> </el-col>
    </el-form>
  </div>
</template>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ProfileEdit",
  data() {
    return {
      form: {
        fileList: [
          {
            name: "food.jpeg",
            url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
          }
        ],
        Username: "",
        Email: "",
        FirstName: "",
        LastName: "",
        Birthday: "",
        PhoneNumber: "",
        CompanySelect: "",
        imagenurl: "",
        /*hobbies: [],
        skills: ["JavaScript", "HTML", "CSS", "Vue.js"],
        gender: "Female",
        address: "",
        city: "",
        country: "",
        postalCode: "", */
        aboutMe: "Comentario"
      },
      imageUrl: this.perfilImage,
      rules: {
        Name: [{ required: true, message: "Nombre es requerido" }],
        CompanySelected: [{ required: true, message: "Empresa es requerido" }],
        Email: [{ required: true, message: "Gerencia es requerida" }],
        FirstName: [{ required: true, message: "El Encargado es requerido" }],
        LastName: [{ required: true, message: "Nombre es requerido" }],
        Birthday: [{ required: true, message: "Empresa es requerido" }],
        PhoneNumber: [{ required: true, message: "Gerencia es requerida" }]
      },

      hobbies: [
        {
          value: "Model building",
          label: "Model building"
        },
        {
          value: "Drawing",
          label: "Drawing"
        },
        {
          value: "Snowboarding",
          label: "Snowboarding"
        }
      ],
      skills: [
        {
          value: "HTML",
          label: "HTML"
        },
        {
          value: "CSS",
          label: "CSS"
        },
        {
          value: "JavaScript",
          label: "JavaScript"
        }
      ],
      labelPosition: "top"
    };
  },
  computed: {
    ...mapState({
      perfilImage: (state) => state.user.imageUrl
    })
  },
  methods: {
    ...mapActions({ asignerImageUrl: "user/asignerImageUrl" }),
    handleSuccessResponse(response) {
      this.asignerImageUrl({ url: response[0].Url });
    },
    getDataById(id) {
      this.l2 = true;
      this.$http
        .get(`/api/users/byId/${id}`)
        .then((resp) => {
          this.l2 = false;
          this.form = resp.data;
        })
        .catch((err) => {
          this.l2 = false;
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },

    onSubmit() {
      this.$http
        .put(`/api/users/${this.form.Id}`, this.form)
        .then(() => {
          this.$message({
            type: "success",
            message: "Actualizado"
          });
        })
        .catch(() => {
          this.message.error("Erro!");
        })
        .finally(() => {
          this.drawer = false;
          this.drawerLoading = false;
          this.form = {};
        });
    },
    resizeLabelPosition() {
      if (window.innerWidth <= 768) {
        this.labelPosition = "top";
      }
    }
  },
  created() {
    this.getDataById(this.currentUser.UserID);
  },
  mounted() {
    this.resizeLabelPosition();
    window.addEventListener("resize", this.resizeLabelPosition);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeLabelPosition);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";

.page-profile-edit {
  .label-switch-box {
    display: block;
    clear: both;
    width: 100%;
    text-align: right;
    margin-bottom: 20px;
  }
  .col-p {
    padding: 0 10px;
    box-sizing: border-box;
  }
  .select-wide {
    width: 100%;
  }
}
</style>
